// Helper function that takes store state and returns the current elapsed time
export default function getElapsedTime(baseTime, startedAt, stoppedAt = new Date().getTime()) {
  if (!startedAt) {
    return 0;
  } else {
    let diffTime = stoppedAt - startedAt + baseTime;
    //console.log(stoppedAt, startedAt, baseTime);
    let date = new Date(null);
    date.setSeconds(Math.floor(diffTime / 1000)); // specify value for SECONDS here
    let result = date.toISOString().substr(11, 8);
    return result;
  }
}


// Distance offsets are minutes after the main race start.
export function getDistanceElapsedTime(baseTime, startedAt, stoppedAt, offsetMinutes = 0, now = Date.now()) {
  if (!startedAt) return '00:00:00';
  const end = stoppedAt === undefined ? now : stoppedAt;
  const elapsedMs = Number(end) - Number(startedAt) + (Number(baseTime) || 0)
    - (Number(offsetMinutes) || 0) * 60000;
  const seconds = Math.max(0, Math.floor(elapsedMs / 1000));
  return [Math.floor(seconds / 3600), Math.floor(seconds / 60) % 60, seconds % 60]
    .map(value => ('0' + value).slice(-2)).join(':');
}



// WEBPACK FOOTER //
// ./src/utils/elapsed-time.js